import { useEffect } from 'react';
import { useFactory, useStrictInstance } from '@funtech-int/rival-react';
import { paymentsRef } from '@funtech-int/yango-shared';

import { PAYMENT_WIDGET_ID_ACQ } from '@/shared/lib/paymentManager';

import styles from './PaymentWidgetOverlay.module.css';

const widgetNode = (): {
    renderElement(): void;
    toggleVisibility(isVisible: boolean): void;
    isMounted: boolean;
} => {
    let overlay: HTMLDivElement;
    let root: HTMLDivElement;
    const renderElement = () => {
        overlay = document.createElement('div');
        overlay.className = styles.overlay;
        root = document.createElement('div');
        root.id = PAYMENT_WIDGET_ID_ACQ;
        root.className = styles.root;
        overlay.appendChild(root);
        document.body.appendChild(overlay);
        return overlay;
    };
    const toggleVisibility = (isVisible: boolean) => {
        if (!overlay) return;
        overlay.classList.toggle(styles.visible, isVisible);
        document.body.classList.toggle(styles.noScroll, isVisible);
    };

    return {
        renderElement,
        toggleVisibility,
        get isMounted() {
            return Boolean(document.getElementById(PAYMENT_WIDGET_ID_ACQ));
        },
    };
};

export const PaymentWidgetOverlay = () => {
    const { modal } = useStrictInstance(paymentsRef);
    const widget = useFactory(widgetNode);

    useEffect(() => {
        if (!widget.isMounted) {
            widget.renderElement();
        }
    }, [widget]);

    useEffect(() => {
        const handleWidgetScenarioChange = () => {
            const currentScenario = modal.scenario.get();
            widget.toggleVisibility(!!currentScenario);
        };

        return modal.scenario.listen(handleWidgetScenarioChange);
    }, [modal.scenario, widget]);

    return null;
};
